import React from "react";
import "./InteriorCard.css";

export default function InteriorCard({ imageSrc, title, description }) {
  return (
    <article className="interior-card">
      <div className="interior-card__media">
        {imageSrc && (
          <img src={imageSrc} alt={title} className="interior-card__img" />
        )}
      </div>

      <div className="interior-card__content">
        <h3 className="interior-card__title">{title}</h3>
        <p className="interior-card__desc">{description}</p>
      </div>
    </article>
  );
}
